export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Motif',
  type: 'motif',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
        title: '',
        options: {

        }
      },
      {
        id: 'metadata-occurences',
        type: 'metadata',
        // grid: 1,
        title: 'resource#occurences',
        options: {
          readmore: {
            height: 250,
            labels: {
              more: 'readmore#more',
              less: 'readmore#less'
            }
          }
        }
      },
      {
        id: 'metadata-motif',
        type: 'metadata',
        title: ''
      },
    ],
  },
};
